import { ChangeEvent, MouseEvent, ReactNode } from 'react'

import { PickerValue } from '../types'
import { useClassNames } from '../utils/useClassNames'

interface BaseCheckboxProps {
  checked: boolean
  value?: PickerValue
  disabled?: boolean
  role?: string
  className?: string
  children?: ReactNode
  onChange?: (
    value: PickerValue | undefined,
    checked: boolean,
    event: ChangeEvent<HTMLInputElement>,
  ) => void
}

const stopPropagation = (event: MouseEvent<HTMLInputElement>) => event.stopPropagation()

export const BaseCheckbox = ({
  checked,
  value,
  disabled,
  role,
  className,
  children,
  onChange,
}: BaseCheckboxProps) => {
  const { merge, prefix, withClassPrefix } = useClassNames('checkbox')

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (disabled) {
      return
    }
    onChange?.(value, !checked, event)
  }

  return (
    <div className={merge(className, withClassPrefix({ disabled, checked }))}>
      <div className={prefix('checker')}>
        <label>
          <span className={prefix('wrapper')} aria-disabled={disabled}>
            <input
              role={role}
              value={value}
              type="checkbox"
              tabIndex={0}
              disabled={disabled}
              aria-disabled={disabled}
              aria-checked={checked}
              onClick={stopPropagation}
              onChange={handleChange}
            />
            <span className={prefix('inner')} aria-hidden role="presentation" />
          </span>
          {children}
        </label>
      </div>
    </div>
  )
}
